module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/bag-chair-9dded48e9b5b27f9bc9da6becab59f95.svg";